import InstitutionStudentSignUpForm from 'components/modules/auth/InstitutionStudentSignUpForm/InstitutionStudentSignUpForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

function InstitutionStudentSignUp() {
  return (
    <AuthCardLayout className="card-sign-up">
      <InstitutionStudentSignUpForm />
    </AuthCardLayout>
  );
}

export default InstitutionStudentSignUp;
